import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Panel from '../../UniformComponents/Panel'
import LandingScreenOption from './LandingScreenOption'

import '../../assets/css/emailLanding.css'
import Button from '../../UniformComponents/Button'
import EmailWizardModal from './EmailBuilder/EmailWizardModal'
import CreateEmailModal from './EmailBuilder/CreateEmailModal'
import CreateEmailListModal from './EmailBuilder/CreateEmailListModal'
import CampaignLinksModal from './CampaignLinks/CampaignLinksModal'
import EmailListMergeFieldModal from './EmailBuilder/EmailListMergeFieldModal'
import PreviewModal from './EmailBuilder/PreviewModal'
import EmailListModal from './EmailBuilder/EmailListModal'
import ErrorModal from './EmailBuilder/ErrorModal'

@observer
export default class DistributionLandingScreen extends Component {
    componentDidMount() {
        const { distributeStore } = this.props

        distributeStore.getSurveyEmbedding()
        distributeStore.init()
    }

    wizardGoToEmail = () => {
        const {
            distributeStore: { showWizardEmailModal },
        } = this.props

        showWizardEmailModal()
    }

    wizardGoToCampaign = () => {
        const { distributeStore } = this.props

        distributeStore.campaignType = 'campaign'
        distributeStore.showCampaignModal()
    }

    wizardGoToOnsite = () => {
        const { distributeStore } = this.props

        distributeStore.campaignType = 'onsite'
        distributeStore.showCampaignModal()
    }

    wizardGoToIntercept = () => {
        const { distributeStore } = this.props

        distributeStore.campaignType = 'intercept'
        distributeStore.showCampaignModal()
    }

    wizardGoToQR = () => {
        const { distributeStore } = this.props

        distributeStore.campaignType = 'qr'
        distributeStore.showCampaignModal()
    }

    render() {
        const {
            distributeStore,
            distributeStore: {
                goToEmail,
            },
            store,
        } = this.props
        const { survey } = store
        const { showBranchBanner } = survey

        return (
            <div className={`email-landing-content ${process.env.USE_NEW_HEADER_UI ? 'survey-view-wrapper' : ''} ${showBranchBanner ? 'branching' : ''}`}>

                <Panel cssClass="email-landing-panel-container">
                    <div className="email-landing-panel-content">
                        <h4>
                            {i18n.t('sch_landing_text')}
                        </h4>

                        <p>
                            {i18n.t('sch_landing_textbelow')}
                        </p>

                        <br />

                        <br />

                        <div className="email-landing-panels">
                            <LandingScreenOption onClick={this.wizardGoToEmail} title={i18n.t('distributionLandingScreen.exploriEmail')} icon="fal fa-envelope" color="green" />

                            <LandingScreenOption onClick={this.wizardGoToCampaign} title={i18n.t('distributionLandingScreen.campaignLink')} icon="fal fa-link-horizontal" color="red" />

                            <LandingScreenOption onClick={this.wizardGoToOnsite} title={i18n.t('distributionLandingScreen.onsite')} icon="fal fa-tablet-screen" color="purple" />
                            {store.isExploriAdmin() && (
                                    <LandingScreenOption onClick={this.wizardGoToIntercept} title={i18n.t('distributionLandingScreen.website')} icon="fal fa-globe" color="blue" />
                            )}
                            <LandingScreenOption onClick={this.wizardGoToQR} title={i18n.t('distributionLandingScreen.qrCode')} icon="fal fa-qrcode" color="dark-blue" />
                        </div>
                    </div>

                    <Button
                        cssClass="regular tertiary"
                        label={i18n.t('distributionLandingScreen.hideWizard')}
                        onClick={goToEmail}
                    />
                </Panel>

                <EmailWizardModal distributeStore={distributeStore} />

                <CreateEmailModal distributeStore={distributeStore} store={store} />

                <CreateEmailListModal distributeStore={distributeStore} />

                <CampaignLinksModal distributeStore={distributeStore} />

                <EmailListMergeFieldModal distributeStore={distributeStore} />

                <PreviewModal distributeStore={distributeStore} />

                <EmailListModal distributeStore={distributeStore} />

                <ErrorModal distributeStore={distributeStore} />
            </div>
        )
    }
}
